import { ActionCardMeta } from './_action_card_meta.component';
import { ActionCardLink, ActionCardRoot } from './_action_card_root.component';
import { ActionCardTitle } from './_action_card_title.component';

export const ActionCard = {
	Root: ActionCardRoot,
	Link: ActionCardLink,
	Title: ActionCardTitle,
	Meta: ActionCardMeta,
};
